<script setup lang="ts">
</script>

<template>
  <UiDefaultPage title="Détails du compte">
    <div class="flex flex-col gap-6 rounded-lg border bg-light p-6 shadow-lg">
      <h3 class="h4">
        Informations personnelles
      </h3>
      <UpdateAccountForm />
    </div>
  </UiDefaultPage>
</template>
